import { Group } from "@mantine/core"
import { ListTableActionIconGroup } from "../../-components/list-table-action-icon-group"
import { useUserLocalStorage } from "../../-components/use-user-local-storage"
import { Page } from "../../../../-components/Page"
import { ResourceTypeCategory } from "../../../../@client/Theasoft_DataClasses_Dispo"
import { ResourceObjectsCardList } from "./ResourceObjectsCardList"
import { ResourceObjectsTable } from "./ResourceObjectsTable"
import { ResourceTypeCategorySelect } from "./ResourceTypeCategorySelect"
import { useNavigate } from "@tanstack/react-router"
import { ResourceObjectsSegmentControl } from "./ResourceObjectsSegmentControl"
import { useGetResourceTypeCategoriesSuspense } from "@/orval/gen"

export function ResourceObjectsPage() {
  const [view, setView] = useUserLocalStorage<"table" | "list">({
    key: "resources-page-view",
    defaultValue: "list",
  })

  const { data: categories } = useGetResourceTypeCategoriesSuspense()

  const [category, setCategory] = useUserLocalStorage<ResourceTypeCategory>({
    key: "resource-category",
    defaultValue: categories[0],
  })
  const navigate = useNavigate()
  const navigateToResources = () =>
    navigate({
      to: "/app/resources/resources",
      search: { filter: { availableCount: 1 } },
    })
  return (
    <Page
      crumbOverride={() => (
        <Group>
          <ResourceTypeCategorySelect value={category} onChange={setCategory} />
          <ResourceObjectsSegmentControl
            category={category}
            value={"Objects"}
            onChange={navigateToResources}
          />
        </Group>
      )}
      buttonGroupProps={{
        children: (
          <ListTableActionIconGroup
            value={view}
            onChange={(value) => {
              setView(value)
            }}
          />
        ),
      }}
      titleGroupProps={{ align: "start" }}
    >
      {view === "list" ? (
        <ResourceObjectsCardList category={category} />
      ) : (
        <ResourceObjectsTable category={category} />
      )}
    </Page>
  )
}
